import React from "react";
import AboutMe from "../components/about-me";

import ProjectGallery from "../components/project-gallery";
import Skills from "../components/skills";


function Homepage(){
   
    return(
        <>
            <AboutMe/>
            <Skills/>
            <ProjectGallery/>
        </>

    )
        
        
        
   
}

export default Homepage